// Third Party
import React from 'react';
import classNames from 'classnames';

// Components
import { IconButton, CloseButton } from '../buttons';
import { Typography } from '@capintel/component-lib/typography';

// Utils
import { ALLOWED_HTML_TAGS } from '../i18n/FormattedMessageV2';
import { formatMessage } from '../../../utils/i18n';

type Props = {
  className?: string;
  hideExpandButton?: boolean;
  title: string;
  onClose: () => void;
  onExpand?: () => void;
  isExpanded: boolean;
};

const EditPortfolioScreenerHeader = ({ title, onClose, onExpand, className, hideExpandButton, isExpanded }: Props) => {
  const tooltip = formatMessage(isExpanded ? 'EditPortfolioModal.CollapseScreener' : 'EditPortfolioModal.ExpandScreener');

  return (
    <div className={classNames('edit-portfolio-screener-header', { className })}>
      {!hideExpandButton && (
        <IconButton
          icon={isExpanded ? 'search-collapse' : 'search-expand'}
          onClick={() => onExpand && onExpand()}
          tooltip={tooltip}
          active={isExpanded}
          round
        />
      )}

      <div className="title">
        <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerSm">
          {title}
        </Typography>
      </div>

      <CloseButton onClick={onClose} customLabel={formatMessage('EditPortfolioModal.CloseScreener')} />
    </div>
  );
};

export default EditPortfolioScreenerHeader;
